<template>
  <div style="height: 100%">
    <iframe id="home-iframe" frameborder="0" width="100%" height="100%"></iframe>
    <!-- dialog start -->
    <div v-show="dialogVisible" class="dialog">
      <div class="dia-con">
        <div class="code">
          <img src="@/assets/ossweb-img/public-code.png" alt="" />
        </div>
        <p class="progress"></p>
      </div>
      <a class="dia-close" title="关闭" @click="dialogVisible = false"></a>
    </div>
    <div v-show="dialogVisible" class="overlay"></div>

    <!-- dialog end -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getToken } from "@/utils/auth";
import { getInstallerInfo } from '@/api/user'
import { aegis } from "@/utils/common";
import {setAegis } from '@/api/project'
import { isProd, getDevMainpage, getDevEAMainpage,downloadFile} from '@/utils/common'

function getOS() {
  let userAgent = navigator.userAgent,
    platform = navigator.platform,
    macOS = /Mac OS X/.test(userAgent),
    windows = /win16|win32|win64|win/i.test(platform),
    ios = /iphone|ipad|ipod/.test(userAgent) && !macOS,
    android = /android/i.test(userAgent);

  if (macOS) return "Mac OS";
  if (windows) return "Windows";
  if (ios) return "iOS";
  if (android) return "Android";

  return "unknown";
}

const windowsUrl =
  "https://desktop.docs.qq.com/Installer/30001/3.5.1/TencentDocs-x86_64.exe?sign=57aaa84b8653e5ab6f2546ba6aa63609&t=1716192066&response-content-disposition=attachment%3Bfilename%3D%22TencentDocs-x8664.exe%22%3Bfilename%2A%3DUTF-8%27%27TencentDocs-x86_64.exe";
const macUrl = windowsUrl;
export default {
  data() {
    return {
      dialogVisible: false,
      hasEaPrivilege:false,
      hasPrivilege:false,
    };
  },
  computed: {
    ...mapGetters(["avatar", "name", "token"]),
  },
  mounted() {
    const iframe = document.querySelector("#home-iframe");
    iframe.src = "/home.html?_t=" + Date.now();
    //  iframe.src ='http://127.0.0.1:8080/'
    window.addEventListener(
      "message",
      (event) => {
        if (!iframe.contentWindow) return;
        if (event.data === "init") {
          let userInfo, hasAdminPrivilege;
          if (this.token) {
            try {
              userInfo = localStorage.getItem("userInfo");
              userInfo = userInfo ? JSON.parse(userInfo) : {};
              hasAdminPrivilege = userInfo.hasAdminPrivilege;
            } catch (error) { }
          }
          iframe.contentWindow.postMessage(
            JSON.stringify({
              avatar: this.token ? this.avatar : "",
              username: this.token ? this.name : "",
              hasAdminPrivilege: hasAdminPrivilege,
              urlOrigin: location.origin,
            }),
            "*"
          );
        } else if (event.data.endsWith && event.data.endsWith("logout")) {
          this.$store.dispatch("user/logout").then(() => {
            this.$store.state.user.token = getToken();
            this.$store.state.app.render = !this.$store.state.app.render;
            location.reload();
          });
          return;
        } else if (
          event.data.startsWith &&
          event.data.startsWith(location.origin)
        ) {
          if (event.data.endsWith("awards/")) {

            window.open(`${location.origin}/#/awards`);
          } else if (event.data.endsWith("dev")) {
            let devUrl = "https://dev.minicreate.qq.com/";
            if (isProd()) {
              devUrl = `https://${getDevMainpage()}/`;
            }
            if(!getToken()) window.open(`/#/oauth?app_id=5012568a421eeb0b&redirect_url=${encodeURIComponent(devUrl)}`);
            else window.open(devUrl);
          } else if (event.data.endsWith("devEA")) {
            let devUrl = "https://dev.minipre.qq.com/";
            if (isProd()) {
              devUrl = `https://${getDevEAMainpage()}/`;
            }
            if(!getToken()) window.open(`/#/oauth?app_id=5012568a421eeb0b&redirect_url=${encodeURIComponent(devUrl)}`);
            else window.open(devUrl);
          } else if (event.data.endsWith("admin")) {
            window.open("/adminfront/");
          } else {
            console.log('event.data', event.data);

            const targetIndex = ['/#/forum/main', '/#/wiki', '/#/learn'].findIndex(i => event.data.endsWith(i));
            // '/forum/main':4
            //  '/#/wiki':5,
            // '/#/learn':6,
            window.open(event.data);
            try {
              // const targetIndex = ['/#/forum/main','/#/wiki','/#/learn'].findIndex(i=>event.data.endsWith(i));
              if (targetIndex !== -1) {
                aegis({ clickarea: 'home', clicktype: targetIndex + 4, });
              }
            } catch (error) {

            }
          }
        } else if (event.data === "signal") {
          this.dialogVisible = true;
        } else if (event.data === "play") {
          aegis({ clickarea: 'home', clicktype: 7, });
        } else if (event.data === "use") {
          //  this.setAegisFunc({ click_area: 'home', click_type: 3, })
          console.log('我点击下载辣');
          // debugger;
          aegis({ clickarea: 'home', clicktype: 3, }).then(() => {
            this.download();
          });
        }
      },
      false
    );
  },
  methods: {
    async download() {
      // if (location.href.includes("https://qyx.qq.com/")) {
      //   return this.$message({
      //     message: "暂未开放，请耐心等待",
      //     type: "info",
      //   });
      // }
      // await aegis({ clickarea: 'home', clicktype: 3, });
      if (!this.token) {
        this.$message({
          message: "请登录后下载",
          type: "info",
        });
        location.href = `/#/oauth?app_id=5012568a421eeb0b&redirect_url=${location.origin}/#/home`
        return
      }
      
      console.log('getInstallerInfo  before');
      const res = await getInstallerInfo();
      console.log('getInstallerInfo  after');
      
      if (res?.ret === 1) {
        const { file_url } = res?.data
        
        const os = getOS();
        if (os === "Mac OS") {
          console.log("getInstallerInfo MacOS",);
          
          downloadFile(file_url);
        } else if (os === "Windows") {
          console.log("getInstallerInfo Windows",);
          
          downloadFile(file_url);
        } else {
          this.$message({
            message: "请使用PC端打开网站",
            type: "info",
          });
        }
      } else {
        this.$message.error(res?.msg ?? '获取链接失败。')
      }
    },
  },
};
</script>
<style scoped>
.dialog .dia-close,
.dialog::after,
.dialog::before {
  width: 2687px;
  height: 1440px;
  background: url(@/assets/ossweb-img/sprite/sprite-1.png) no-repeat;
  background-size: 2687px 1440px;
}

.dialog {
  width: 1416px;
  height: 533px;
  background: url(@/assets/ossweb-img/dialog.png) no-repeat;
}

.dialog::before {
  content: "";
  position: absolute;
  top: -152px;
  left: -70px;
  width: 199px;
  height: 281px;
  background-position: -764px -628px;
}

.dialog::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: -41px;
  width: 139px;
  height: 176px;
  background-position: -330px -1136px;
}

.dialog .dia-close {
  position: absolute;
  right: 0;
  top: -114px;
  width: 87px;
  height: 87px;
  background-position: -2504px -518px;
}

.dialog .dia-con {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.dialog .code {
  width: 256px;
  height: 256px;
  background-color: #00c2d2;
  border-radius: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 112px;
  position: relative;
}

.dialog .code::after {
  content: "";
  position: absolute;
  right: -55px;
  bottom: 0;
  width: 1px;
  height: 256px;
  background-color: #00b6ce;
  box-shadow: 1px 0 0 0 #fff;
}

.dialog .code img {
  width: 245px;
  height: 245px;
  box-sizing: border-box;
  border: 2px solid #fddf8b;
  border-radius: 18px;
  overflow: hidden;
}

.dialog .progress {
  width: 820px;
  height: 340px;
  background: url(@/assets/ossweb-img/progress.png) no-repeat;
}

.dialog {
  position: fixed;
  z-index: 9999;
  left: 50%;
  top: 50%;
  margin-top: -266.5px;
  margin-left: -708px;
}

.overlay {
  background-color: rgb(0, 0, 0);
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 9997;
  left: 0px;
  top: 0px;
  opacity: 0.7;
}

.dialog-title {
  position: relative;
  width: 100%;
  font-size: 18px;
}

.el-dialog__close {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 20px;
  cursor: pointer;
}

.mod-dialog-content {
  display: flex;
  justify-content: space-around;
  padding: 20px;
}

.mod-dialog-content div {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.mod-dialog-content div>.el-button {
  padding: 16px 32px;
  font-size: 19px;
  display: flex;
  font-weight: bold;
  /* padding-left: 28px;
  padding-right: 28px; */
}

.mod-dialog-content div>div {
  margin-top: 10px;
  font-size: 12px;
  font-weight: bold;
}

.mod-dialog-content .disabled{
  -webkit-filter: grayscale(100%); /* Chrome, Safari, Opera */
    filter:grayscale(100%);
    /* pointer-events: disabled; */
    /* pointer-events: none; */
    
}
.mod-dialog-content .disabled:hover{
  cursor: not-allowed;
}

/* 确保 el-dialog 垂直居中 */
::v-deep.dialog-download .el-dialog{
  height: 245px;
  margin-top: calc(50vh - 148px) !important;
  background: url('@/assets/img/Group 363.png') no-repeat;
  background-size:cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
/* ::v-deep.dialog-download .el-dialog .el-dialog__header{
  display: none;
} */
</style>
